/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon20Light = forwardRef('ArrowDCornerRightUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.354 7.146a.5.5 0 0 1-.708.708L13 3.207V14a3 3 0 0 1-3 3H1.5a.5.5 0 1 1 0-1H10a2 2 0 0 0 2-2V3.207L7.354 7.854a.5.5 0 1 1-.708-.708l4.652-4.651a1.7 1.7 0 0 1 2.404 0l4.652 4.651Z" })));
});
